import api from './api'

export interface MessageTemplate {
    id: number
    name: string
    content: string
    // content - разметка Telegram (жирный, курсив, цитата...).
    is_formatted?: boolean
    category: string | null
    usage_count: number
    created_at: string
}

export interface MessageTemplatePayload {
    name: string
    content: string
    category?: string | null
    is_formatted?: boolean
}

// Настройка общая на систему: включает её администратор, а панель появляется
// сразу у всех операторов.
export const messageTemplatesApi = {
    getSettings: () => api.get<{ enabled: boolean }>('/message-templates/settings'),

    updateSettings: (enabled: boolean) =>
        api.put<{ enabled: boolean }>('/message-templates/settings', { enabled }),

    getTemplates: () => api.get<MessageTemplate[]>('/message-templates'),

    createTemplate: (data: MessageTemplatePayload) =>
        api.post<MessageTemplate>('/message-templates', data),

    updateTemplate: (templateId: number, data: MessageTemplatePayload) =>
        api.put<MessageTemplate>(`/message-templates/${templateId}`, data),

    deleteTemplate: (templateId: number) => api.delete(`/message-templates/${templateId}`),

    markUsed: (templateId: number) => api.post(`/message-templates/${templateId}/use`),
}
